module.exports = __webpack_public_path__ + "img/video_img.a9d84bfc.png";